const testimonials = [
  {
    name: "Jennifer & Mark R.",
    location: "Westminster, CO — Standley Lake area",
    rating: 5,
    text: "Booked a trip to Paris for our anniversary and realized my passport only had 3 months left — France requires 6 months validity. Called Fast Passport Center and they had my expedited renewal back in 5 business days. Made our flight from DIA with no issues at all. The process was seamless and their communication throughout was excellent.",
    service: "Expedited Passport Renewal",
  },
  {
    name: "Tom H.",
    location: "Westminster, CO — Tech corridor",
    rating: 5,
    text: "Software architect here. I got a last-minute invitation to a product summit in Tokyo and my passport was expired. Fast Passport Center handled my emergency renewal in 3 business days. I shipped documents Monday morning, had my new passport Wednesday afternoon, and flew from DIA Thursday. Incredible turnaround. Way better than trying to navigate the Aurora passport agency.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "The Nakamura Family",
    location: "Broomfield, CO",
    rating: 5,
    text: "We planned a family ski trip to Whistler and discovered both our kids had expired passports — oops. Fast Passport Center handled both renewals at the same time and got them back within 7 business days. The family trip was saved and the kids had an amazing time on the slopes. Highly recommend for Colorado families planning Canada ski trips.",
    service: "Family Expedited Renewals",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Westminster &amp; North Denver Metro Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Westminster, Broomfield, and Arvada travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}